export const TRANSACTION_TEMPLATE_RULE = (id: number) =>
  `transactionRule/transactionTemplate/${id}`;

export const DELETE_TRANSACTION_TEMPLATE_RULE = (id: number) =>
  `transactionRule/deleteTemplateRule/${id}`;
